













































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import ParameterCategoryApi from '@/api/goods/parameter/category'

@Component({
  components: {
    CustomForm
  }
})
export default class GoodsParameter extends AbpBase {
  isCheckAll: boolean = false
  columns: any[] = [
    // {
    //   type: 'selection',
    //   width: 60,
    //   align: 'center'
    // },
    {
      title: '编号',
      key: 'id',
      align: 'center'
    },
    {
      title: '参数分类名称',
      key: 'name',
      align: 'center'
    },
    {
      title: '排序',
      width: 100,
      align: 'center',
      key: 'displayOrder'
    },
    {
      title: '操作',
      slot: 'action',
      width: 270,
      align: 'center'
    }
  ]
  loading: boolean = false
  tableData: any[] = []
  currentPage = 1
  pageSize = 10
  totalCount = 0

  filters = [
    {
      label: '参数分类名称：',
      type: 'input',
      rule: { required: true, message: '请输入参数分类名称', trigger: 'blur' },
      key: 'name'
    },
    {
      label: '规格排序：',
      type: 'input-number',
      key: 'displayOrder',
      props: {
        min: 0
      }
    }
  ]
  editId: any = null
  editModal: boolean = false

  // 列表页内编辑
  handleEdit(row?) {
    this.editId = (row && row.id) || ''
    this.editModal = true
    let $formEdit: any = this.$refs.formEdit
    if (row) {
      // 编辑设值
      $formEdit.setForm(row)
    } else {
      // 新增清空
      $formEdit.reset()
    }
  }

  closeModel() {
    ;(this.$refs.formEdit as any).reset()
    this.editModal = false
  }

  modalOk() {
    let $form: any = this.$refs.formEdit
    $form.submit()
  }

  onSubmit(form, valid) {
    if (valid) {
      let obj: any = {}
      let { displayOrder, name } = form
      Object.assign(obj, { displayOrder, name })
      ParameterCategoryApi.edit(this.editId, obj).then(res => {
        this.$Message.success(this.editId ? '修改成功' : '添加成功')
        this.editModal = false
        this.getTableData()
      })
    }
  }

  // 列表数据操作
  created() {
    this.getTableData()
  }

  getTableData() {
    let { pageSize, currentPage } = this
    ParameterCategoryApi.getList(pageSize, currentPage)
      .then(res => {
        this.loading = false
        let { totalCount, items } = res.data
        this.totalCount = totalCount
        this.tableData = items
      })
      .catch(() => {
        this.loading = false
        this.totalCount = 0
        this.tableData = []
      })
  }

  getProductSalesAttributeValues(arr: any[]) {
    return arr.map(item => item.name).join('，')
  }

  deleteRow(row: any) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.handleDelete(row.id)
      }
    })
  }

  handleDelete(id: string | number) {
    ParameterCategoryApi.deleteById(id).then(res => {
      this.getTableData()
    })
  }

  handleTableAllCancel() {
    this.isCheckAll = false
  }

  handleTableAll() {
    this.isCheckAll = true
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
  }

  handleSelectAll() {
    if (!this.tableData.length) return
    ;(this.$refs.selection as any).selectAll(!this.isCheckAll)
  }

  deleteSelectd() {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      console.log('执行删除')
      this.$Modal.confirm({
        title: '批量删除商品规格',
        content: `是否删除已选中的商品规格?`,
        onOk: () => {
          console.log('点了确定了')
        }
      })
    }
  }

  pageChange(currentPage) {
    this.currentPage = currentPage
    this.getTableData()
  }
  pageSizeChange(pageSize) {
    this.pageSize = pageSize
    this.currentPage = 1
    this.getTableData()
  }
}
